import React, { SVGAttributes } from 'react'

const SvgDuplicate = (props: SVGAttributes<SVGElement>): JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 12 14" {...props}>
    <path
      fill="#313537"
      fillRule="evenodd"
      d="M12 3.138c0-.08-.083-.161-.083-.161l-3-2.816s-.084 0-.084-.08c0 0-.083 0-.083-.081H2.667c-.25 0-.5.241-.5.483v2.414H.5c-.25 0-.5.24-.5.482v10.138c0 .242.25.483.5.483h8.833c.25 0 .5-.241.5-.483v-2.414H11.5c.25 0 .5-.24.5-.482V3.138zM9.083 1.77l1.167 1.046H9.083V1.77zM8 5.713H6.917V4.667L8 5.713zM6.333 6.759H8.75v6.356H1V3.943h4.833v2.252c0 .322.25.564.5.564zm3.5-.564v-.16c0-.081-.083-.081-.083-.161l-3-2.817s-.083 0-.083-.08c0 0-.084 0-.084-.08H3.167V1.046h4.916v2.253c0 .322.167.563.5.563H11v6.356H9.833V6.195z"
    />
  </svg>
)

export default SvgDuplicate
